import { getDefaultRedirectPath } from './redirectByRole';

/** Маршруты, доступные smm_manager (синхронно с backend rbac). */
const SMM_ALLOWED_PATHS = ['/mailings', '/dialogs', '/prompts'];

export function normalizeRole(role) {
  return (role || '').trim().toLowerCase();
}

export function hasFullPanelAccess(role) {
  const r = normalizeRole(role);
  if (!r || r === 'smm_manager') {
    return false;
  }
  return true;
}

export function canAccessPath(role, pathname) {
  const r = normalizeRole(role);
  if (r !== 'smm_manager') {
    return true;
  }
  return SMM_ALLOWED_PATHS.includes(pathname);
}

export function getAccessDeniedRedirect(role) {
  return getDefaultRedirectPath(role);
}
